module.exports = new __parcel__URL__("image-product-3.1f3a9183.jpg").toString();